module.exports = __webpack_public_path__ + "a6b3be6e259a8df72f12d46df547882f.jpg";